module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="sh-modal did-you-mean-modal" data-url="DidYouMean">\n    <div class="sh-modal-container">\n        <div class="sh-modal-inner">\n            <div class="sh-modal-header">\n                <h3 class="title text-center">';
 if (results.length) { ;
__p += 'Multiple Addresses Found';
 } else { ;
__p += 'No Address Found';
 } ;
__p += '</h3>\n                <button class="close"><i class="Icon icon-times"></i></button>\n            </div>\n            ';
 if (results.length) { ;
__p += '\n            <div class="sh-modal-content">\n                <h2 class="title">Which one do you want?</h2>\n                <div class="list-row">\n                    ';
 each(results, function(result, index) { ;
__p += '\n                        <button data-index="' +
((__t = ( index )) == null ? '' : __t) +
'">' +
((__t = ( result.formatted_address )) == null ? '' : __t) +
'</button>\n                    ';
 }); ;
__p += '\n                </div>\n            </div>\n            ';
 } ;
__p += '\n        </div>\n    </div>\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./spothero/static/main/templates/modals/did-you-mean-modal.html
// module id = 441
// module chunks = 0